// extracted by mini-css-extract-plugin
export var readonly = "_g1-1";
export var star = "_g1-0";